<div class="hf-calculator-page-wrapper" id="scrollerid">
  <div class="calculator-steps-wrapper">
    <div class="back-btn-wrapper">
      <mat-icon class="back-btn" (click)="onBackBtnClicked()">arrow_back</mat-icon>
      <div class="title-mob" *ngIf="util.isMobile()">{{info.mobTitle}}</div>
    </div>
    <div class="content-wrapper">
      <div class="top-content-img-wrappper" *ngIf="util.isMobile()">
        <img src="/assets/images/health-first/calculator-top-decorator-mob.svg" altt="img">
      </div>
      <div class="top-content" [ngClass]="{'step2onwards': step > 0}">
        <div class="header">
          <div class="title">{{info?.steps[step]?.topContent?.title}}</div>
          <div class="sub-title">{{info?.steps[step]?.topContent?.subTitle}}</div>
          <div class="desc">{{info?.steps[step]?.topContent?.desc}}</div>
        </div>
        <ng-container *ngIf="step === 0" [ngTemplateOutlet]="step1"></ng-container>
        <ng-container *ngIf="step === 1" [ngTemplateOutlet]="step2"></ng-container>
        <ng-container *ngIf="step === 2" [ngTemplateOutlet]="step3"></ng-container>
        <ng-container *ngIf="step === 3" [ngTemplateOutlet]="step4"></ng-container>
      </div>
      <ng-container *ngIf="!util.isMobile()">
        <!-- progress bar -->
        <div class="progress-bar">
          <mat-progress-bar [mode]="isLoading ? 'indeterminate':'determinate'" [value]="progressBarValue"></mat-progress-bar>
        </div>
        <!-- content -->
        <div class="bottom-content">
          <ng-container [ngTemplateOutlet]="bottomDocRef"></ng-container>
        </div>
      </ng-container>
    </div>
    <div *ngIf="util.isMobile()" class="bottom-content-dock" [ngClass]="{'pos-abs-bottom': step !== 1, 'b-neg7perc': step === 2, 'b-neg18perc': step === 3}">
      <div class="bottom-img-wrapper">
        <img src="/assets/images/health-first/calculator-bottom-decorator-mob.svg" alt="img">
      </div>
      <!-- progress bar -->
      <div class="progress-bar">
        <mat-progress-bar [mode]="isLoading ? 'indeterminate':'determinate'" [value]="progressBarValue"></mat-progress-bar>
      </div>
      <!-- content -->
      <div class="bottom-content">
        <ng-container [ngTemplateOutlet]="bottomDocRef"></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #bottomDocRef>
  <div class="text-content">
    <div class="title">
      {{info.steps[step].bottomContent.title}}
    </div>
    <div class="sub-title">
      {{info.steps[step].bottomContent.subTitle}}
    </div>
  </div>
  <div class="continue-btn-wrapper">
    <app-button label="Continue" [isLoading]="isLoading" [btnClass]="getBtnClass()" [disabled]="getDisableStateContdBtn()" (btnClick)="onContinueClicked()"></app-button>
  </div>
</ng-template>

<ng-template #step1>
  <div class="form-wrapper">
    <div class="mobile-wrapper step-1">
      <div class="mob-prefix">+91 - </div>
      <app-input [errorMessage]="errorMessage" [group]="step1Form" [control]="step1Form.get('mobile')" label="Mobile number" placeHolder="99999 00000" inputType="number" [disableWheel]="true" (enter)="verifyUserDetails()"></app-input>
      <div class="verify-btn">
        <app-button [label]="sendOtpClicked ? 'resend otp':'verify'" [isLoading]="isLoading" [btnClass]="(step1Form.get('mobile').value.length === 10 && this.step1Form.get('mobile').valid ? '': 'disabled ') + 'hf-secondary-btn form-btn mat-elevation-z0'" [disabled]="step1Form.get('mobile').value.length === 0" (btnClick)="verifyUserDetails()"></app-button>
      </div>
    </div>
    <app-input *ngIf="showOtp" inputType="number" [disableWheel]="true" [errorMessage]="errorMessage" [group]="step1Form" [control]="step1Form.get('otp')" label="OTP" placeHolder="OTP" (enter)="onContinueClicked()"></app-input>
    <app-input *ngIf="showSignupForm" inputType="text" [errorMessage]="errorMessage" [group]="step1Form" [control]="step1Form.get('name')" label="Name" placeHolder="Name" ></app-input>
    <app-input *ngIf="showSignupForm" inputType="email" [errorMessage]="errorMessage" [group]="step1Form" [control]="step1Form.get('email')" label="Email" placeHolder="Email Address" ></app-input>
    <app-captcha></app-captcha>
  </div>
</ng-template>

<ng-template #step2>
  <div class="form-wrapper">
    <div class="mobile-wrapper" *ngFor="let item of step2InfoArr" [formArray]="step2Form">
      <div class="title">
        {{item.title}}
      </div>
      <div class="input-wrapper" [ngClass]="{'column-3': item.val === 0, 'column-date': item.isDateOpen && item.val === 0, 'date-column-2': item.isDateOpen && item.val !== 0}">
        <app-input [errorMessage]="errorMessage" [group]="step2Form" [control]="step2Form.controls[item.val].get('name')" [placeHolder]="step2Info[item.val].placeholder" (OnChange)="onNameAddStep2($event, item.val)"></app-input>
        <span class="self-block" *ngIf="item.val === 0">Self</span>
        <div class="verify-btn" *ngIf="!item.isDateOpen" [ngClass]="{'c-disable': !item.isDateOpen && step2Form.controls[item.val].get('name').value.length === 0}">
          <app-button label="Add DOB" (btnClick)="toggleDatePicker(item, picker)" [btnClass]="(step2Form.controls[item.val].get('name').value.length > 0 ? '': 'disabled ') + 'hf-secondary-btn form-btn mat-elevation-z0'" [disabled]="step2Form.controls[item.val].get('name').value.length === 0"></app-button>
        </div>
        <div class="date-wrapper" [hidden]="!item.isDateOpen">
          <mat-form-field class="w-50">
            <input matInput [matDatepicker]="picker" [formControl]="step2Form.controls[item.val].get('age')" placeholder="DOB" [min]="item.minDate" [max]="item.maxDate" (focus)="picker.open()">
            <mat-datepicker #picker panelClass="hf-date"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="bmi-wrapper">
        <div class="height-wrapper">
          <div class="ft-wrapper">
            <app-input label="Height (ft)" [errorMessage]="heightFtErrorMsg" [max]="9" [min]="1" inputType="number" [disableWheel]="true" [group]="step2Form" [control]="step2Form.controls[item.val].get('heightFt')" [placeHolder]="step2Info[item.val].heightFt"></app-input>
          </div>
          <div class="inch-wrapper">
            <app-input label='Height (inch)' [errorMessage]="heightInchErrorMsg" [max]="11" [min]="0" inputType="number" [disableWheel]="true" [group]="step2Form" [control]="step2Form.controls[item.val].get('heightInch')" [placeHolder]="step2Info[item.val].heightInch"></app-input>
          </div>
        </div>
        <div class="weight-wrapper">
          <app-input label="Weight" [errorMessage]="weightErrorMsg" [group]="step2Form" [control]="step2Form.controls[item.val].get('weight')" [placeHolder]="step2Info[item.val].weight" [disableWheel]="true" inputType="number"></app-input>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #step3>
  <div class="form-wrapper" [ngClass]="{'w-370': util.isMobile(),'w-400': !util.isMobile()}">
    <app-input [group]="step3Form" [errorMessage]="errorMessage" [control]="step3Form.get('avgSpendsOnMedicine')" label="Avg. Spends on Medicines" placeHolder="Avg. Spends on Medicines" inputType="number" [disableWheel]="true" min="0"></app-input>
    <app-select [group]="step3Form" [data]="clinicalVisitOption" [control]="step3Form.get('annualClinicVisit')" label="Annual Clinic Visits" placeHolder="Annual Clinic Visits" ></app-select>
    <app-input [group]="step3Form" [group]="step3Form" [errorMessage]="errorMessage"  [control]="step3Form.get('avgSpendsOnLabTest')" label="Avg. Spends on Lab Test" placeHolder="Avg. Spends on Lab Test" inputType="number" [disableWheel]="true" min="0"></app-input>
  </div>
</ng-template>

<ng-template #step4>
  <div class="form-wrapper" [ngClass]="{'w-370': util.isMobile(),'w-400': !util.isMobile()}">
    <app-select [group]="step4Form" [data]="yesOrNoOptions" [control]="step4Form.get('anySmoker')" label="Does anyone in your family smoke?" placeHolder="Does anyone in your family smoke?" ></app-select>
    <app-select [group]="step4Form" [data]="yesOrNoOptions" [control]="step4Form.get('anyDrinker')" label="Any drinkers in your family?" placeHolder="Any drinkers in your family?" ></app-select>
    <app-select [group]="step4Form" [data]="yesOrNoOptions" [control]="step4Form.get('anyTobacco')" label="Anyone in the family using tobacco?" placeHolder="Anyone in the family using tobacco?" ></app-select>
  </div>
</ng-template>
